import React, { useRef, useState } from 'react';
import type { DraggableData, DraggableEvent } from 'react-draggable';
import Draggable from 'react-draggable';
import { Button, Modal } from 'antd';
import { HolderOutlined } from '@ant-design/icons';
import { BaseButton } from '../../UI/BaseButton';

export type DraggableModalProps = {
  initialPositionStyles: React.CSSProperties;
  modalContent: React.ReactNode;
  renderButton: (open: boolean) => React.ReactNode;
  modalDragTitle: React.ReactNode;
  open: boolean;
  setOpen: (open: boolean) => void;
};

const DraggableModal = (props: DraggableModalProps) => {
  const open = props.open;
  const setOpen = props.setOpen;
  const [disabled, setDisabled] = useState(true);
  const [bounds, setBounds] = useState({
    left: 0,
    top: 0,
    bottom: 0,
    right: 0,
  });
  const draggleRef = useRef<HTMLDivElement>(null);

  const toggleModal = () => {
    setOpen((curr) => !curr);
  };

  const handleOk = (e: React.MouseEvent<HTMLElement>) => {
    console.log(e);
    setOpen(false);
  };

  const handleCancel = (e: React.MouseEvent<HTMLElement>) => {
    console.log(e);
    setOpen(false);
  };

  const onStart = (_event: DraggableEvent, uiData: DraggableData) => {
    const { clientWidth, clientHeight } = window.document.documentElement;
    const targetRect = draggleRef.current?.getBoundingClientRect();
    if (!targetRect) {
      return;
    }
    setBounds({
      left: -targetRect.left + uiData.x,
      right: clientWidth - (targetRect.right - uiData.x),
      top: -targetRect.top + uiData.y,
      bottom: clientHeight - (targetRect.bottom - uiData.y),
    });
  };

  return (
    <div className="" key={String(open)}>
      <BaseButton onClick={toggleModal} type="secondary" size="medium" active={open}>
        {props.renderButton(open)}
      </BaseButton>
      <Modal
        style={{
          top: 20,
          right: 20,
          position: 'absolute',
          // so the area weher the modal was initailly doesn't block clicks
          pointerEvents: 'none',
          //
          ...props.initialPositionStyles,
        }}
        width={360}
        wrapClassName="custom-draggable-modal"
        title={
          <div
            style={{
              width: '100%',
              cursor: 'move',
            }}
            onMouseOver={() => {
              if (disabled) {
                setDisabled(false);
              }
            }}
            onMouseOut={() => {
              setDisabled(true);
            }}
            // fix eslintjsx-a11y/mouse-events-have-key-events
            // https://github.com/jsx-eslint/eslint-plugin-jsx-a11y/blob/master/docs/rules/mouse-events-have-key-events.md
            onFocus={() => {}}
            onBlur={() => {}}
            // end
          >
            <div className="flex justify-start items-center gap-2">
              <HolderOutlined />
              <span className="text-xl font-semibold leading-7">{props.modalDragTitle}</span>
            </div>
          </div>
        }
        open={open}
        footer={null}
        // onOk={handleOk}
        onCancel={handleCancel}
        mask={false} // Set mask prop to false to remove the transparent gray background
        maskClosable={false} // Set maskClosable prop to false to prevent closing on click outside
        modalRender={(modal) => (
          <Draggable
            disabled={disabled}
            bounds={bounds}
            nodeRef={draggleRef}
            onStart={(event, uiData) => onStart(event, uiData)}
          >
            <div ref={draggleRef}>{modal}</div>
          </Draggable>
        )}
      >
        {props.modalContent}
      </Modal>
    </div>
  );
};

export default DraggableModal;
